var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#424b54","d":"M5.34,0a5.34,5.34,0,1,0,5.34,5.34A5.34,5.34,0,0,0,5.34,0Zm0,9.65A4.31,4.31,0,1,1,9.65,5.34,4.31,4.31,0,0,1,5.34,9.65Z","key":0}),React.createElement("path",{"fill":"#e9c46a","d":"M6.67,7.4,4.84,6.07a.28.28,0,0,1-.1-.21V2.33A.25.25,0,0,1,5,2.07h.68a.25.25,0,0,1,.26.26V5.38l1.44,1a.26.26,0,0,1,.06.36L7,7.34a.26.26,0,0,1-.36.06Z","key":1})]);
}

Clock.defaultProps = {"viewBox":"0 0 10.68 10.68"};

module.exports = Clock;

Clock.default = Clock;
